module.exports = __webpack_public_path__ + "stationary-availability.svg?bdc7b4a9c38c7c33484e96a37d495ddc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stationary-availability.svg
// module id = 97
// module chunks = 2